export interface Step {
	title?: string;
	button?: string;
	buttonAction: Function;
}

export enum KycModalFlowStep {
	DATA_UPDATE,
	SUCCESS
}
